// extracted by mini-css-extract-plugin
export default {"label":"NodeEditor_label__+2UWn"};